import { render, staticRenderFns } from "./FormatSortSelector.vue?vue&type=template&id=4cbb3cf2&scoped=true&"
import script from "./FormatSortSelector.vue?vue&type=script&lang=ts&"
export * from "./FormatSortSelector.vue?vue&type=script&lang=ts&"
import style0 from "./FormatSortSelector.vue?vue&type=style&index=0&id=4cbb3cf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbb3cf2",
  null
  
)

export default component.exports